import React from 'react';
import { AppBar, Toolbar, Typography, Box, Avatar, IconButton, Tooltip } from '@mui/material';
import { Star, Build } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" elevation={0} sx={{ backgroundColor: 'transparent', color: 'white' }}>
      <Toolbar>
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {/* Logo placeholder - replace with your actual logo */}
            <Box
              component="img"
              sx={{
                height: 40,
                width: 'auto',
                display: { xs: 'none', sm: 'block' }
              }}
              alt="National Residential Property Standards Award"
              src="/images/National-Residential-Property-Standards-Award.png"
              onError={(e) => {
                // Fallback to star icon if logo not found
                e.currentTarget.style.display = 'none';
                const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                if (nextElement) {
                  nextElement.style.display = 'flex';
                }
              }}
            />
            {/* Fallback avatar with star icon */}
            <Avatar sx={{ bgcolor: 'secondary.main', display: 'flex' }}>
              <Star />
            </Avatar>
            <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
              NRPSA Score
            </Typography>
          </Box>
        </motion.div>
        <Box sx={{ flexGrow: 1 }} />
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
              Property Compliance Health Check
            </Typography>
            <Tooltip title="Developer Dashboard">
              <IconButton
                onClick={() => navigate('/dev')}
                sx={{ 
                  color: 'white', 
                  opacity: 0.7,
                  '&:hover': { opacity: 1 }
                }}
                size="small"
              >
                <Build fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </motion.div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;